import { Object, String, Number, Static, Intersect, Array, Enum, Integer, Optional } from '@sinclair/typebox';

import { ValueOf } from '../../utils';

export type CodeName = Static<typeof CodeName>;
export const CodeName = Object({
  code: String(),
  name: String(),
});

export enum TripType {
  ONE_WAY = 'one-way',
  ROUND_TRIP = 'round-trip',
  OPEN_JAW = 'open-jaw',
  CIRCLE_TRIP = 'circle-trip',
}

export const BonusProgramItem = CodeName;
export type BonusProgramItem = Static<typeof BonusProgramItem>;

export const Country = Intersect([
  CodeName,
  Object({
    cities: Array(
      Intersect([
        CodeName,
        Object({
          airports: Array(CodeName),
        }),
      ])
    ),
  }),
]);
export type Country = Static<typeof Country>;

export const enum BOUND_SIDE {
  Outbound = 'outbound',
  Inbound = 'inbound',
}

export const BoundSide = Enum({
  Outbound: BOUND_SIDE.Outbound,
  Inbound: BOUND_SIDE.Inbound,
});

export enum BaggageUnitType {
  KILOGRAM = 'KG',
  POUND = 'POUNDS',
  PIECES = 'PIECES',
}

export const AwardBaggageDetails = Object({
  unit: Enum(BaggageUnitType),
  value: Integer(),
  text: String(),
});
export type AwardBaggageDetails = Static<typeof AwardBaggageDetails>;

export const AwardBaggageAllowance = Object({
  outbound: Optional(AwardBaggageDetails),
  inbound: Optional(AwardBaggageDetails),
});

export type AwardBaggageAllowance = Static<typeof AwardBaggageAllowance>;

export type RatelimitErrorReponse = Static<typeof RatelimitErrorReponse>;
export const RatelimitErrorReponse = Object({
  payload: Object({
    remainingTime: Optional(Number()),
    message: Optional(String()),
  }),
  bookingErrorType: String(),
});

export const ScheduledDateTime = Object({
  local: String(),
  utc: String(),
});
export type ScheduledDateTime = Static<typeof ScheduledDateTime>;

export const SplitDuration = Object({
  years: Optional(Number()),
  months: Optional(Number()),
  weeks: Optional(Number()),
  days: Optional(Number()),
  hours: Optional(Number()),
  minutes: Optional(Number()),
  seconds: Optional(Number()),
});

export type SplitDuration = Static<typeof SplitDuration>;

export const NonEligibilityReasons = Object({ code: String(), title: String() });
export type NonEligibilityReasons = Static<typeof NonEligibilityReasons>;

export type Channel = ValueOf<typeof Channel>;
export const Channel = {
  WEB: 'WEB',
  APP: 'APP',
} as const;
